import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function MultiSelectCheckbox({ options, selectedOptions, onChange, placeholder }) {
  return (
    <FormControl sx={{ m: 1, width: 300 }}>
      <InputLabel id="multi-select-checkbox-label">{placeholder}</InputLabel>
      <Select
        labelId="multi-select-checkbox-label"
        id="multi-select-checkbox"
        multiple
        value={selectedOptions}
        onChange={onChange}
        input={<OutlinedInput label={placeholder} />}
        renderValue={(selected) =>
          selected.map((value) => options.find(option => option.value === value)?.label).join(', ')
        }
        MenuProps={MenuProps}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selectedOptions.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultiSelectCheckbox;
